import {
  UPDATE_PROVIDER_SUCCESS,
  UPDATE_PROVIDER_FAILED,
  CLEAR_UPDATE_PROVIDER,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROVIDER_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case UPDATE_PROVIDER_FAILED:
      return { ...state, status: 'error', error: action.error };

    case CLEAR_UPDATE_PROVIDER:
      return { ...initialState, status: 'clear' };
    default:
      return state;
  }
};
